import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  HostListener,
} from "@angular/core";
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig, MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { PageEvent as PageEvent } from "@angular/material/paginator";
import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";

import { ModalDirective } from "ngx-bootstrap/modal";
import { map } from "rxjs/operators";
import { MediaService } from "../../common/media.service";
import { AddEditFolderComponent } from "../folders/add-edit-folder/add-edit-folder.component";
import { MediaUploadDialogComponent } from "../media-upload-dialog/media-upload-dialog.component";
import { ManageMediaComponent } from "./manage-media/manage-media.component";
import { MoveDialogComponent } from "./manage-media/move-dialog/move-dialog.component";
import { Folder } from "../../common/data-models";
import { Types } from "src/app/models/media-types-extensions.model";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { slideTrigger } from "src/app/events-calendar/common/animation/triggers/slideTrigger";
import { SecurityComponent } from "src/app/views/security/security.component";
import { forkJoin } from "rxjs";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-media-folders",
  templateUrl: "./media-folders.component.html",
  styleUrls: ["./media-folders.component.css"],
  animations: [
    slideTrigger,
    trigger("zipper", [
      state(
        "collapsed",
        style({
          height: "0px",
          overflow: "hidden",
          paddingTop: "0px",
          paddingBottom: "0px",
        })
      ),
      state(
        "expanded",
        style({
          height: "*",
          paddingTop: "*",
          paddingBottom: "*",
        })
      ),
      transition("collapsed <=> expanded", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class MediaFoldersComponent implements OnInit {
  @Input() view: string = "grid";
  @Input() data: any = {};
  @Input() searchText: string = "";
  @Input() isMultiSelect: boolean = false;
  @Input() files: any[] = [];
  @Input() fromDialog: boolean = false;
  openedParentFolders = new Map();
  parentFoldersCounter = new Map();
  isFolder: boolean = true;
  totalMediaLength: number;
  mediaExtensions: Types[] = [];
  mediaTypes: Types[] = [];
  totalFolderLength: number;
  currentFolder;
  activeTab = true;
  activeTabForMedia = true;
  assignedRoles;
  // selectedMediaType: number[] = [];
  // selectedMediaExtension: number[] = [];
  // filterStatus = 2;
  isWebP: any = true;
  // --- Pre-upload image optimization (client-side, canvas-based) -----------
  // Applies to JPG/PNG/WebP only: SVG is vector and GIF would lose animation.
  // The optimized file keeps the ORIGINAL name and mime type, so the server's
  // webp conversion, the 409 replace-by-filename flow and the media listing
  // all keep working unchanged. The smaller of original/optimized is uploaded.
  compressImages = false;
  /** Encoder quality in percent (JPEG/WebP; PNG is lossless so only resize applies). */
  compressQuality = 75;
  resizeImages = false;
  /** Longest side cap in px — larger images are scaled down proportionally. */
  resizeMaxWidth = 1920;
  private static readonly OPTIMIZABLE_IMAGE_TYPES = [
    "image/jpeg",
    "image/png",
    "image/webp",
  ];
  searchTextValue = "";
  // public selectedFiles: any[] = [];
  //  @Input() isMultiSelect: boolean = false;
  cultureId = 0;
  public selectedMedia = new Map();
  public selectedFolders = new Map();

  @Output() selectedFiles = new EventEmitter<any>();
  constructor(
    public mediaManagerService: MediaService,
    private snotifyService: ToastrService,
    private dialog: MatDialog
  ) { }
  public filter = {
    PageNumbermedia: 0,
    PageSizemedia: 10,
    PageSizefolder: 10,
    PageNumberfolder: 0,
  };

  ngOnInit() {
    if (!this.fromDialog) {
      this.mediaManagerService.getFoldersFirstTime();
      this.getSbreadCrumb(null);
    }

    this.calculateSubFolders();
    this.getTypes();
    this.getExtensions();
    this.totalMediaLength = this.data.totalCountsMedia;
    this.totalFolderLength = this.data.totalCountsFolder;
    this.mediaManagerService.media$.subscribe((res: any) => {
      this.totalMediaLength = res.totalCountsMedia;
      this.totalFolderLength = res.totalCountsFolder;
    });
  }





  updateSecurity() {

    if ([...this.selectedMedia.keys()].length && ![...this.selectedFolders.keys()].length) {
      let mediaId = [...this.selectedMedia.keys()][0];
      this.mediaManagerService
        .getAssignedRolesMedia(mediaId)
        .subscribe((res: any) => {

          this.assignedRoles = [...res.assingedRoles]
          let dialogRef = this.dialog.open(SecurityComponent, {
            width: "70vw",
            data: {
              unAssigendRole: [...this.selectedMedia.keys()].length > 1 ? [...res.unassingedRoles, ...res.assingedRoles] : res.unassingedRoles,
              assigendRoles: [...this.selectedMedia.keys()].length > 1 ? [] : res.assingedRoles,
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              result.assigendRoles = result.assigendRoles.map((x) => x.id);
              let rolesAndAsigend: any = {
                addMediaRole: [...this.selectedMedia.keys()].length > 1 ? {
                  mediaIds: [...this.selectedMedia.keys()],
                  roleIds: result.assigendRoles,
                } : null,
                "mediaId": [...this.selectedMedia.keys()].length <= 1 ? mediaId : null,
                "roleIds": [...this.selectedMedia.keys()].length <= 1 ? result.assigendRoles : null
              };

              this.mediaManagerService
                .updateAssignedRolesMedia(rolesAndAsigend)
                .subscribe((res) => {
                  this.snotifyService.success("Roles updated successfully");
                });
            }
          });
        });



    } else if (![...this.selectedMedia.keys()].length && [...this.selectedFolders.keys()].length) {

      let folderId = [...this.selectedFolders.keys()][0];
      this.mediaManagerService
        .getAssignedFolder(folderId)
        .subscribe((res: any) => {

          this.assignedRoles = [...res.assingedRoles]
          let dialogRef = this.dialog.open(SecurityComponent, {
            width: "70vw",
            data: {
              unAssigendRole: [...this.selectedFolders.keys()].length > 1 ? [...res.unassingedRoles, ...res.assingedRoles] : res.unassingedRoles,
              assigendRoles: [...this.selectedFolders.keys()].length > 1 ? [] : res.assingedRoles,
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              result.assigendRoles = result.assigendRoles.map((x) => x.id);
              let rolesAndAsigend: any = {
                "folderIds": [...this.selectedFolders.keys()],
                "roleIds": result.assigendRoles
              };

              this.mediaManagerService
                .updateAssignedRolesFolder(rolesAndAsigend)
                .subscribe((res) => {
                  this.snotifyService.success("Roles updated successfully");
                });
            }
          });
        });


    } else if ([...this.selectedMedia.keys()].length && [...this.selectedFolders.keys()].length) {
      let folderId = [...this.selectedFolders.keys()][0];
      let mediaId = [...this.selectedMedia.keys()][0];

      this.mediaManagerService
        .getAssignedFolder(folderId)
        .subscribe((res: any) => {
          this.assignedRoles = [...res.assingedRoles];
          let dialogRef = this.dialog.open(SecurityComponent, {
            width: "70vw",
            data: {
              unAssigendRole: [...res.unassingedRoles, ...res.assingedRoles],
              assigendRoles: [],
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              result.assigendRoles = result.assigendRoles.map((x) => x.id);

              let rolesAndAsigendForFolder: any = {
                "folderIds": [...this.selectedFolders.keys()],
                "roleIds": result.assigendRoles
              };

              let rolesAndAsigendForMedia: any = {
                addMediaRole: [...this.selectedMedia.keys()].length > 1 ? {
                  mediaIds: [...this.selectedMedia.keys()],
                  roleIds: result.assigendRoles,
                } : null,
                mediaId: [...this.selectedMedia.keys()].length <= 1 ? mediaId : null,
                roleIds: [...this.selectedMedia.keys()].length <= 1 ? result.assigendRoles : null,
              };

              forkJoin({
                folderUpdate: this.mediaManagerService.updateAssignedRolesFolder(rolesAndAsigendForFolder),
                mediaUpdate: this.mediaManagerService.updateAssignedRolesMedia(rolesAndAsigendForMedia)
              }).subscribe(
                (results) => {
                  this.snotifyService.success("Roles updated successfully");
                },
                (error) => {
                  this.snotifyService.error("An error occurred while updating roles");
                }
              );
            }
          });
        });

    }


    //     let mediaId = [...this.selectedMedia.keys()][0];
    //     this.mediaManagerService
    //       .getAssignedRolesMedia(mediaId)
    //       .subscribe((res: any) => {
    //         console.log('assingedRoles @@@@@@@@@@@@');

    //         console.log(res.unassingedRoles,'assingedRoles @@@@@@@@@@@@');
    // this.assignedRoles=[...res.assingedRoles]
    //         let dialogRef = this.dialog.open(SecurityComponent, {
    //           width: "70vw",
    //           data: {
    //             unAssigendRole: res.unassingedRoles,
    //             assigendRoles: res.assingedRoles,
    //           },
    //         });

    //         dialogRef.afterClosed().subscribe((result) => {
    //           if (result) {
    //             console.log("result");

    //             console.log(result);
    //             result.assigendRoles = result.assigendRoles.map((x) => x.id);
    //             let rolesAndAsigend: any = {
    //               addMediaRole: this.assignedRoles.length==0?{
    //                 mediaIds: [...this.selectedMedia.keys()],
    //                 roleIds: result.assigendRoles,
    //               }:null,
    //               "mediaId": this.assignedRoles.length?mediaId:null,
    //               "roleIds": this.assignedRoles.length?result.assigendRoles:null
    //             };
    //             console.log(rolesAndAsigend,'rolesAndAsigend !!!!!!!!!!!!!');

    //             this.mediaManagerService
    //               .updateAssignedRolesMedia(rolesAndAsigend)
    //               .subscribe((res) => {
    //                 console.log(res ,'res of updateAssignedRoles ##########');
    //                 this.snotifyService.success("Roles updated successfully");
    //               });
    //           }
    //         });
    //       });
  }

  changeActiveStep() {
    this.activeTab = !this.activeTab;
  }
  changeActiveStepForMedia() {
    this.activeTabForMedia = !this.activeTabForMedia;
  }

  getExtensions() {
    this.mediaManagerService.getMediaExtensions().subscribe((res: Types[]) => {
      this.mediaExtensions = res;
    });
  }
  getTypes() {
    this.mediaManagerService.getMediaTypes().subscribe((res: Types[]) => {
      this.mediaTypes = res;
    });
  }

  onerror(media) {
    media.errorClass = true;
    media.publicUrl = "assets/media/files/jpg.svg";
  }

  drag(id) { }
  search() {
    this.selectedFolders.clear();
    this.selectedMedia.clear();
    this.mediaManagerService.filter = { ...this.filter };
    // this.filter.PageNumbermedia = 0;
    // this.filter.PageNumberfolder = 0;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    this.mediaManagerService.searchMediaAndFolders().subscribe((res: any) => {
      // this.totalMediaLength = res.totalCountsMedia;
      // this.totalFolderLength = res.totalCountsFolder;
    });
  }
  SideSearch(e) {
    this.mediaManagerService.getAllSideFolders(e);
  }



  // drop(event: CdkDragDrop<string[]>) { //
  // moveItemInArray(this.items, event.previousIndex, event.currentIndex); }


  getSubItems(folder) {
    this.selectedFolders.clear();
    this.selectedMedia.clear();
    // this.filter.PageNumbermedia = 0;
    // this.filter.PageNumberfolder = 0;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    this.mediaManagerService.getfolderId = folder.id;

    this.isFolder = false;
    this.currentFolder = folder;
    this.mediaManagerService
      .searchMediaAndFolders(folder.id)
      .subscribe((res: any) => {
        this.mediaManagerService.isParentIdChanged(
          folder.id,
          folder.name,
          res.parentFolderId,
          folder.itemCount,
          res.currentFolderBreadcrumb
        );
        this.totalMediaLength = res.totalCountsMedia;
        this.totalFolderLength = res.totalCountsFolder;
        this.mediaManagerService.filter.PageNumbermedia = 0;
        this.mediaManagerService.filter.PageNumberfolder = 0;
      });
  }

  public getSbreadCrumb(id, folder?: any) {
    // this.selectedFolderId = id;
    this.selectedFolders.clear();
    this.selectedMedia.clear();
    this.mediaManagerService.filter.PageNumbermedia = 0;
    this.mediaManagerService.filter.PageNumberfolder = 0;
    this.mediaManagerService.searchMediaAndFolders(id).subscribe((res: any) => {
      this.mediaManagerService.isParentIdChanged(
        res.currentFolderId,
        res.currentFolderName,
        res.parentFolderId,
        res.itemCount,
        res.currentFolderBreadcrumb
      );
    });
  }
  getBack() {
    this.mediaManagerService.searchMediaAndFolders().subscribe((res: any) => {
      this.mediaManagerService.isParentIdChanged(
        res.currentFolderId,
        res.currentFolderName,
        res.parentFolderId,
        res.itemCount,
        res.currentFolderBreadcrumb
      );
    });
  }

  selectFile(file: any) {
    // if (this.isMultiSelect) {

    if (this.selectedMedia.get(file.id)) {
      this.selectedMedia.delete(file.id);
    } else {
      this.selectedMedia.set(file.id, file);
    }
    // if (this.selectedMedia && this.selectedMedia.length > 0) {
    //   let index = this.selectedMedia.findIndex((x) => x.id == file.id);
    //   index != -1
    //     ? this.selectedMedia.splice(index, 1)
    //     : this.selectedMedia.push(file);
    // } else {
    //   this.selectedMedia.push(file);
    // }

    this.selectedFiles.emit(this.selectedMedia);
    // }
    //  else this.selectedFiles.emit(file);
  }
  selectAllMedia(event, files: any[]) {
    if (event.checked)
      for (let media of files) {
        if (!this.selectedMedia.get(media.id)) {
          this.selectedMedia.set(media.id, media);
        }
      }
    else this.selectedMedia.clear();
  }

  public isFileSelected(File) {
    for (let index = 0; index < this.selectedMedia.size; index++) {
      const element = this.selectedMedia[index];
      if (element.id == File.id) {
        return index;
      }
    }
    return -1;
  }

  setAsFolderThumbnail(media) {
    const payload = {
      ThumbnailId: media.id,
      Id: media.folderId,
      Name: media.filename,
    };

    this.mediaManagerService
      .setAsFolderThumbnail(payload)
      .subscribe((res) =>
        this.openNotifySuccess("Set As Thumnail Suaccsessfly")
      );
  }

  public deleteFolder(ids: any, action: number) {
    if (action == 2) {
      //cconfirm alert
    }
    this.mediaManagerService.deleteFolder(ids, action).subscribe(
      (res: any) => {
        this.selectedFolders.clear();
        this.openNotifySuccess(res.status.body);
        //this.mediaManagerService.folder.parentId = res.currentFolderId;

        this.mediaManagerService.folder$.subscribe();
        this.mediaManagerService.getAllSideFolders();
        this.getSbreadCrumb(this.mediaManagerService.folder.parentFolderId)
        this.mediaManagerService
          .searchMediaAndFolders(this.mediaManagerService.folder.parentFolderId)
          .subscribe((res) => {
          });
      },
      (err: any) => {
        this.openNotifyError("Something Went Wrong!");
      }
    );
  }

  manageMedia(media) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "60%";

    dialogConfig.height = "80%";

    dialogConfig.panelClass = "modal-media";
    dialogConfig.data = media;
    this.dialog
      .open(ManageMediaComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => { });
  }
  copyUrl(url: string) {
    let selBox = document.createElement("textarea");
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  public openNotifyError(message: string) {
    this.snotifyService.error(message, "Something Went Wrong!!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  manageFolder(method) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.height = "100%";
    // dialogConfig.panelClass = "modal-media";

    dialogConfig.data = {
      method: method,
      folder: this.mediaManagerService.folder,
    };
    this.dialog
      .open(AddEditFolderComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        this.calculateSubFolders();
      });
  }

  public deleteSideFolder(ids: number[], action: number) {
    this.mediaManagerService.filter = { ...this.filter };
    //     this.filter.PageNumbermedia = 0;
    // this.filter.PageSizemedia = 10;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    this.mediaManagerService.deleteFolder(ids, action).subscribe(
      (res: any) => {
        this.openNotifySuccess(res.status.body);
        this.selectedFolders.clear();
        this.mediaManagerService.folder.parentId = res.currentFolderId;
        this.mediaManagerService.searchMediaAndFolders().subscribe();
        this.mediaManagerService.getFoldersFirstTime();
        //  console.log( 'rootCount',this.mediaManagerService.folder$.pipe(map(x=>x.rootCount)))
        // this.mediaManagerService.folder$.
      },
      (err: any) => {
        this.openNotifyError(err.message);
      }
    );
  }

  // public dropFromFolder(event, folderId) {
  //    //   var drag = [];
  //   drag.push(event.dragData.toString());

  //   console.log(this.data.folders);
  //   if (this.data.folders.length > 0) {
  //     var isFolder = false;
  //     this.data.folders.forEach((element) => {
  //       if (element["id"] == event.dragData) {
  //         console.log("it is folders");
  //         isFolder = true;
  //       }
  //     });
  //   }

  //   if (isFolder) {
  //     this.moveFolders(event, folderId);
  //   } else {
  //     this.mediaManagerService
  //       .moveMedia([event.dragData], folderId || 0)
  //       .subscribe((res: any) => {
  //         this.getSbreadCrumb(null);

  //         this.openNotifySuccess("Media successfully moved.");
  //         // this.mediaManagerService
  //         //   .getMediaById(
  //         //     this.mediaManagerService.folder.parentId
  //         //       ? this.mediaManagerService.folder.parentId
  //         //       : 0
  //         //   )
  //         //   .subscribe();
  //         this.mediaManagerService.getFoldersFirstTime();
  //         this.mediaManagerService.folder$.subscribe();
  //         this.mediaManagerService.getAllSideFolders();
  //       });
  //   }
  // }
  isDragging = false;

  onDragStart(): void {
    this.isDragging = true;
  }

  onDragEnd(): void {
    this.isDragging = false;
  }
  public dropFromFolder(event: CdkDragDrop<any>, folderId, isMedia?): void {
    // let folderId = event.item.data.folderId
    // Instead of event.dragData, use event.item.data from CDK
    if (isMedia) {
      return
    }
    const draggedItemId = event.item.data.folderId;

    let isFolder = false;

    // Check if the dragged item is among your folder list
    if (this.data.folders && this.data.folders.length > 0) {
      this.data.folders.forEach((element) => {
        if (element.id == draggedItemId) {
          isFolder = true;
        }
      });
    }

    if (isFolder) {
      // If it's a folder, perform your folder-moving logic
      if (draggedItemId == folderId) {
        return
      }
      this.moveFolders(draggedItemId, folderId);
    } else {
      // Otherwise, assume it's a media item and call your service
      this.mediaManagerService
        .moveMedia([draggedItemId], folderId || 0)
        .subscribe((res: any) => {
          this.getSbreadCrumb(null);
          this.openNotifySuccess("Media successfully moved.");

          // Update your local or global folder data
          this.mediaManagerService.getFoldersFirstTime();
          this.mediaManagerService.folder$.subscribe();
          this.mediaManagerService.getAllSideFolders();
        });
    }
  }

  // deletedMedia;
  openDelete(template: TemplateRef<any>, isAside = false) {
    // this.deletedMedia = media;
    this.dialog.open(template, { width: "40%", data: { isAside: isAside } });
  }
  public deleteMedia(ids: number[], action) {
    this.mediaManagerService.filter = { ...this.filter };
    // this.filter.PageNumbermedia = 0;
    // this.filter.PageSizemedia = 10;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    this.mediaManagerService.deleteMedia(ids, action).subscribe(
      (res: any) => {
        this.selectedMedia.clear();
        this.dialog.closeAll();
        this.openNotifySuccess(res.body);
        this.mediaManagerService
          .searchMediaAndFolders(this.mediaManagerService.folder.parentId)
          .subscribe((res) => {
          });
        this.mediaManagerService.getAllSideFolders();
      },
      (err: any) => {
        this.openNotifyError("Something Went Wrong!");
      }
    );
  }

  deleteFoldersAndMedia(action: number, isAsideFolder?) {
    if (this.selectedMedia.size) {
      this.deleteMedia([...this.selectedMedia.keys()], action);
    }

    if (this.selectedFolders.size || isAsideFolder) {
      var arrOfFolders = this.selectedFolders.size
        ? [...this.selectedFolders.keys()]
        : [];
      if (isAsideFolder)
        arrOfFolders.push(this.mediaManagerService.folder.parentId);
      this.deleteFolder(arrOfFolders, action);
    }
  }

  async changePage(event: PageEvent) {
    this.mediaManagerService.filter.PageNumbermedia = event.pageIndex;
    this.mediaManagerService.filter.PageSizemedia = event.pageSize;
    this.mediaManagerService.filter.PageNumberfolder = event.pageIndex;
    this.mediaManagerService.filter.PageSizefolder = event.pageSize;
    let id;
    id = this.mediaManagerService.currentFolderId;

    this.currentFolder = { id: id };

    if (!this.currentFolder.id) {
      this.mediaManagerService
        .searchMediaAndFolders(this.mediaManagerService.folder.parentId)
        .subscribe();
    } else {
      this.getSubFolders(this.currentFolder);
    }
  }
  getData() {
    // this.mediaManagerService
    // .getFolders(media.folderId ? media.folderId : 0, true).pipe(
    //   switchMap((x) => {
    //     return this.mediaManagerService.getFoldersFirstTime()
    //   }),
    //   switchMap((x) => {
    //     return this.mediaManagerService.getFolders(media.folderId ? media.folderId : 0, true)
    //   })
    // )
    // .subscribe();
  }
  cancelDelete() {
    this.dialog.closeAll();
  }

  getSubFolders(folder) {
    this.mediaManagerService.search.searchText = ""
    if (folder.id == this.mediaManagerService.folder.parentId) {
      this.mediaManagerService.folder = {};
      this.returnSearchToDefault();
      this.search();

      return;
    }

    this.selectedFolders.clear();
    this.selectedMedia.clear();

    if (this.currentFolder && this.currentFolder.id != folder.id) {
      this.mediaManagerService.filter = { ...this.filter };

      this.currentFolder = folder;
      this.searchTextValue = "";
      this.searchText = "";
    } else if (!this.currentFolder) {
      this.mediaManagerService.filter = { ...this.filter };
      this.currentFolder = folder;
      this.searchTextValue = "";
      this.searchText = "";
    }

    // if (folder.id != this.mediaManagerService.folder.parentId) {
    this.mediaManagerService
      .searchMediaAndFolders(folder.id)
      .subscribe((res: any) => {
        this.mediaManagerService.isParentIdChanged(
          folder.id,
          folder.name,
          res.parentFolderId,
          folder.itemCount,
          res.currentFolderBreadcrumb
        );
        this.totalMediaLength = res.totalCountsMedia;
        this.totalFolderLength = res.totalCountsFolder;
        this.returnSearchToDefault();
      });
    // }
  }

  isWebPChanges() {
    this.mediaManagerService.isWebpForDialogMedia = this.isWebP;
  }

  returnSearchToDefault() {
    // this.searchText = "";
    // this.filterStatus = 2;
    // (this.selectedMediaExtension = []), (this.selectedMediaType = []);
  }
  status: boolean = false;
  public async onFilesAdded(event) {
    this.mediaManagerService.filter = { ...this.filter };
    // this.filter.PageNumbermedia = 0;
    // this.filter.PageSizemedia = 10;
    // this.filter.PageSizefolder = 10;
    // this.filter.PageNumberfolder = 0;
    var formData = new FormData();
    formData.append("CultureId", this.cultureId.toString());

    if (this.mediaManagerService.folder.parentId) {
      formData.append(
        "ParentId",
        this.mediaManagerService.folder.parentId.toString()
      );
    }
    const uploads = await this.optimizeForUpload(event.addedFiles || []);
    for (var i = 0; i < uploads.length; i++) {
      formData.append("Uploads", uploads[i]);
    }

    formData.append("ConvertToWebp", this.isWebP);
    //to do
    //ConvertToWebp

    // if(this.status){
    //   this.replaceMedia()
    // }
    this.mediaManagerService.saveMedia(formData).subscribe(
      (res: any) => {
        this.openNotifySuccess("Media Uploaded Successfuly");
        // this.getSbreadCrumb(null)
        this.mediaManagerService
          .searchMediaAndFolders(this.mediaManagerService.folder.parentId)
          .subscribe((res) => {
          });
        this.mediaManagerService.getAllSideFolders();
      },
      (err: any) => {
        if (err.status == 409) {
          this.replaceMedia(formData);
          this.mediaManagerService.searchMediaAndFolders().subscribe();
          this.mediaManagerService.getAllSideFolders();
        } else {
          this.openNotifyError(err.message);
          this.mediaManagerService.media$.subscribe((m: any) => {
            if (m.media) {
              let name = m.media.find(
                (x) => x.filename == event.addedFiles[0].name
              );
              if (name) {
                this.replaceMedia(formData);
                this.mediaManagerService.searchMediaAndFolders().subscribe();
                this.mediaManagerService.getAllSideFolders();
              }
            }
          });
        }

        // console.log('error =', err);
      }
    );
  }

  // Runs the selected pre-upload optimizations over the dropped files.
  // Never blocks an upload: any decode/encode failure falls back to the
  // original file, and an optimized copy is used only when it is SMALLER.
  private async optimizeForUpload(files: File[]): Promise<File[]> {
    if ((!this.compressImages && !this.resizeImages) || !files.length) {
      return files;
    }
    let bytesBefore = 0;
    let bytesAfter = 0;
    let optimizedCount = 0;
    const out: File[] = [];
    for (const file of files) {
      const optimized = await this.optimizeImage(file).catch(() => null);
      if (optimized && optimized.size < file.size) {
        bytesBefore += file.size;
        bytesAfter += optimized.size;
        optimizedCount++;
        out.push(optimized);
      } else {
        out.push(file);
      }
    }
    if (optimizedCount) {
      this.openNotifySuccess(
        `${optimizedCount} image(s) optimized: ${this.formatBytes(
          bytesBefore
        )} → ${this.formatBytes(bytesAfter)}`
      );
    }
    return out;
  }

  /** Resize/re-encode one image on a canvas. Returns null when the file is not
   * an optimizable image or there is nothing to do (the caller then uploads
   * the original). Keeps the original name + mime type on purpose. */
  private async optimizeImage(file: File): Promise<File | null> {
    if (!MediaFoldersComponent.OPTIMIZABLE_IMAGE_TYPES.includes(file.type)) {
      return null;
    }
    const { source, width, height, close } = await this.loadImageSource(file);
    try {
      let targetW = width;
      let targetH = height;
      if (this.resizeImages && this.resizeMaxWidth > 0) {
        const longest = Math.max(width, height);
        if (longest > this.resizeMaxWidth) {
          const scale = this.resizeMaxWidth / longest;
          targetW = Math.max(1, Math.round(width * scale));
          targetH = Math.max(1, Math.round(height * scale));
        }
      }
      const resizing = targetW !== width || targetH !== height;
      // PNG is lossless — the encoder ignores quality, so compression alone
      // can't shrink it here; only resizing applies.
      const lossy = file.type !== "image/png";
      if (!resizing && !(this.compressImages && lossy)) return null;

      const canvas = document.createElement("canvas");
      canvas.width = targetW;
      canvas.height = targetH;
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      ctx.drawImage(source, 0, 0, targetW, targetH);
      const quality =
        this.compressImages && lossy
          ? Math.min(0.95, Math.max(0.4, this.compressQuality / 100))
          : undefined;
      const blob = await new Promise<Blob | null>((res) =>
        canvas.toBlob(res, file.type, quality)
      );
      if (!blob) return null;
      return new File([blob], file.name, {
        type: file.type,
        lastModified: Date.now(),
      });
    } finally {
      close?.();
    }
  }

  /** Decode an image file, preferring createImageBitmap (honors EXIF
   * orientation); falls back to an <img> element on older browsers. */
  private loadImageSource(
    file: File
  ): Promise<{
    source: CanvasImageSource;
    width: number;
    height: number;
    close?: () => void;
  }> {
    if (typeof createImageBitmap === "function") {
      return createImageBitmap(file, {
        imageOrientation: "from-image",
      } as any).then((bmp) => ({
        source: bmp,
        width: bmp.width,
        height: bmp.height,
        close: () => bmp.close(),
      }));
    }
    return new Promise((resolvePromise, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolvePromise({
          source: img,
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
      img.onerror = (e) => {
        URL.revokeObjectURL(url);
        reject(e);
      };
      img.src = url;
    });
  }

  private formatBytes(bytes: number): string {
    if (bytes >= 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + " MB";
    if (bytes >= 1024) return Math.round(bytes / 1024) + " KB";
    return bytes + " B";
  }

  getPaginationData(e) {
    this.totalMediaLength = e.totalCountsMedia;
    this.totalFolderLength = e.totalCountsFolder;
  }
  replaceMedia(form: FormData) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.panelClass = "modal-media";

    dialogConfig.data = form;
    this.dialog
      .open(MediaUploadDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res == "replace")
          this.openNotifySuccess("Media replaced Successfuly");
      });
  }

  folder = []
  subfolders = []
  media = []
  pushIds(id) {
    if (!this.folder.find(x => x == id)) {
      this.folder.push(id)
      this.media.push(id)
      return this.folder
    }
    return this.folder



  }


  moveFolders(current, parent) {
    this.mediaManagerService
      .moveFolders([current], parent)
      .subscribe(() => {
        this.openNotifySuccess("Successfully moving");
        this.getSbreadCrumb(null);
        this.mediaManagerService.getFoldersFirstTime();
        this.mediaManagerService.getAllSideFolders();
      });
  }
  moveMedia() {
    const dialogRef = this.dialog.open(MoveDialogComponent, {
      width: "700px",
      height: "500px",
      data: {
        selectedMedia: this.selectedMedia,
        selectedFolders: this.selectedFolders,
      },
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result == "submit") {
          // this.returnSearchToDefault();
          this.mediaManagerService.getAllSideFolders();
          this.openNotifySuccess(
            ` [${this.selectedMedia.size + this.selectedFolders.size
            }] item moved successfully.`
          );
          this.selectedMedia.clear();
          this.selectedFolders.clear();
        }

        // ... do something with the result if needed
      },
      (err) => {
        this.openNotifyError("Something Went Wrong !");
      }
    );
  }
  downloadMedia() {
    for (let key of this.selectedMedia.keys()) {
      const a = document.createElement("a");
      a.href = this.selectedMedia.get(key).publicUrl;
      a.download = this.selectedMedia.get(key).filename || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  selectFolder(folder: Folder) {
    if (this.selectedFolders.get(folder.id)) {
      this.selectedFolders.delete(folder.id);
    } else {
      this.selectedFolders.set(folder.id, folder);
    }
  }
  selectAllFolders(event, data) {
    if (event.checked)
      for (let folder of data.folders) {
        if (!this.selectedFolders.get(folder.id)) {
          this.selectedFolders.set(folder.id, folder);
        }
      }
    else {
      this.selectedMedia.clear();
      this.selectedFolders.clear();
    }
  }
  openSubFolder(event, folder) {

    event.stopPropagation();
    if (this.openedParentFolders.get(folder.id))
      this.openedParentFolders.delete(folder.id);
    else this.openedParentFolders.set(folder.id, folder);
  }

  calculateSubFolders() {
    this.mediaManagerService.allSideFolders$.subscribe((res) => {
      if (res)
        for (let struct of res.structure) {
          this.parentFoldersCounter.set(struct.id, struct.items.length);
        }
    });
  }

  // filterMedia(status) {
  //   this.mediaManagerService.search.filterStatus = status;
  //   this.mediaManagerService
  //     .searchMediaAndFolders()
  //     .subscribe((res) => {
  //     });
  // }
  restoreMedia() {
    var parentFolderIds = [];
    for (let key of this.selectedMedia.keys()) {
      let media = this.selectedMedia.get(key);
      if (media && media.folderId) parentFolderIds.push(media.folderId);
    }
    this.mediaManagerService
      .restoreMedia([...this.selectedMedia.keys()], parentFolderIds)
      .subscribe(
        () => {
          this.returnSearchToDefault();
          this.search();
          this.openNotifySuccess("Media Retrieved Successfully");
          this.mediaManagerService.searchMediaAndFolders().subscribe();
          this.mediaManagerService.getAllSideFolders();
        },
        (err) => {
          this.openNotifyError("Something Went Wrong !");
        }
      );
  }

  restoreFolders() {
    this.mediaManagerService
      .restoreFolders(
        [...this.selectedFolders.keys()]
        // parentFolderIds
      )
      .subscribe(
        () => {
          this.returnSearchToDefault();
          this.search();
          this.openNotifySuccess("Folders Retrieved Successfully");
          this.mediaManagerService.searchMediaAndFolders().subscribe();
          this.mediaManagerService.getAllSideFolders();
        },
        (err) => {
          this.openNotifyError("Something Went Wrong !");
        }
      );
  }

  restoreItems() {
    if (this.selectedMedia.size) {
      this.restoreMedia();
    }

    if (this.selectedFolders.size) {
      this.restoreFolders();
    }
  }
}
